import { updateOnboardingStore } from './onboardingStore';
import { updatePriceStore } from './priceStore';
import { updateUserStore } from './userStore';

export const resetStores = () => {
  updateUserStore('resetUser')();
  updateOnboardingStore('resetOnboarding')();
  updatePriceStore('resetPrice')();
};
